import React from 'react'

export default function Team() {
	return (
		<div id="team" className="team">
			<div className="container-main w-container">
				<h2 className="h2">Meet the Team</h2>
				<div className="content-div _1" />
				<div className="w-layout-grid team-flex">
					<div className="member">
						<div className="member-info-wrap">
							<div className="member-name">
								<p className="p1 light">SEED</p>
								<div className="social-media-wrapper">
									<a
										href="#_"
										target="_blank"
										className="round-social-wrapper tw _1em-right-margin w-inline-block">
										<img
											src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e444dbf012c2f4c7c1c8c3_Twitter.svg"
											loading="lazy"
											alt="Twitter icon blue"
										/>
									</a>
									<a
										href="#"
										target="_blank"
										className="round-social-wrapper w-inline-block">
										<img
											src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61f799783504a20801e64507_icons8-portfolio-20.png"
											loading="lazy"
											alt=""
										/>
									</a>
								</div>
							</div>
							<div className="member-position">
								<p className="p1 light">Founder</p>
							</div>
						</div>
						<div className="member-image-wrap">
							<img
								src="assets/collections/team-1.png"
								alt=""
								className="member-image"
							/>
						</div>
					</div>
					<div className="member">
						<div className="member-info-wrap">
							<div className="member-name">
								<p className="p1 light">ELIOT</p>
								<div className="social-media-wrapper">
									<a
										href="#"
										target="_blank"
										className="round-social-wrapper w-inline-block">
										<img
											src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e444db8d89ef6eed863ce8_Instagram.svg"
											loading="lazy"
											alt="Instagram icon blue"
										/>
									</a>
								</div>
							</div>
							<div className="member-position">
								<p className="p1 light">Developer</p>
							</div>
						</div>
						<div className="member-image-wrap">
							<img
								src="assets/collections/team-2.png"
								alt=""
								className="member-image"
							/>
						</div>
					</div>
					<div className="member">
						<div className="member-info-wrap">
							<div className="member-name">
								<p className="p1 light">Izzy</p>
								<div className="social-media-wrapper">
									<a
										href="#"
										target="_blank"
										className="round-social-wrapper w-inline-block">
										<img
											src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e444db8d89ef6eed863ce8_Instagram.svg"
											loading="lazy"
											alt="Instagram icon blue"
										/>
									</a>
								</div>
							</div>
							<div className="member-position">
								<p className="p1 light">Advisor </p>
							</div>
						</div>
						<div className="member-image-wrap">
							<img
								src="assets/collections/team-3.png"
								alt=""
								className="member-image"
							/>
						</div>
					</div>
				</div>
			</div>
			{/* <div className="container-main-2 margin-up discord-banner w-container">
				<div className="tarot-wrap-2">
					<div className="name-wrap-2">
						<div className="text-block-10">join-discord.community</div>
						<div>
							<img
								src="https://uploads-ssl.webflow.com/618c22f054db156e23e92b6a/618c22f054db156070e92b8f_Group%2093.svg"
								loading="lazy"
								alt=""
								className="image-6"
							/>
						</div>
					</div>
					<div className="tarot-content-2">
						<div>
							<h3 className="h3-2 title-margin">Join the Dippie community</h3>
							<a
								href="https://discord.gg/dippies"
								target="_blank"
								className="hero-cta-2 w-button">
								JOIN&nbsp;OUR DISCORD
							</a>
						</div>
					</div>
				</div>
			</div> */}
		</div>
	)
}
